/**
 * /vocal2 (CONC3) : DPI simulé (page /dpi, sondage 1 s) en plein écran +
 * fenêtre vocale flottante en verre (FloatingPanel DS, VREC1). Chaque saisie validée passe
 * par le concentrateur (DPI_BACKEND=concentrateur) puis apparaît au sondage suivant.
 * Pilotage SON en dev (US-VMPL-002) : `frontend/son/Vocal2Son.tsx`.
 */
import { lazy, Suspense, useState } from 'react';
import type { ComponentType, ReactNode } from 'react';
import { DpiLivePage } from '@/features/admin/pages/DpiLivePage';
import { FloatingPanel } from '@/shared/ds/patterns';
import { VOICE_COLOR } from '@/shared/ds/patterns/VoiceRecorder/voiceStates';
import type { VoiceRecorderState } from '@/shared/ds/patterns/VoiceRecorder/VoiceRecorder';
import { HoriPage } from './HoriPage';
import styles from './VocalDpiPage.module.css';

/** US-VMPL-002 : pilotage SON en dev seulement — `frontend/son` n'est monté qu'en dev ; ailleurs le glob est vide. */
const chargeurs = import.meta.glob<{ Vocal2Son: ComponentType<{ children: ReactNode }> }>(
  '../../../../son/Vocal2Son.tsx',
);
const charger = import.meta.env.VITE_SON_GATEWAY ? Object.values(chargeurs)[0] : undefined;
const Vocal2Son = charger ? lazy(() => charger().then((m) => ({ default: m.Vocal2Son }))) : null;

export function VocalDpiPage() {
  const [voiceSt, setVoiceSt] = useState<VoiceRecorderState>('off');
  const page = (
    <div className={styles.page}>
      <div className={styles.dpi} data-son="vocal2/dpi">
        <DpiLivePage />
      </div>
      <FloatingPanel storageKey="hrl-vocal2-panel" gripLabel="Déplacer la fenêtre vocale" glow={VOICE_COLOR[voiceSt]}>
        <HoriPage compact onVoiceState={setVoiceSt} />
      </FloatingPanel>
    </div>
  );
  return Vocal2Son ? (
    <Suspense fallback={null}>
      <Vocal2Son>{page}</Vocal2Son>
    </Suspense>
  ) : (
    page
  );
}
